import { Component, OnInit, ViewChild } from '@angular/core';
import { Paginator } from 'primeng/paginator';
import { ICategory } from 'src/app/shared/interfaces/category';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { ApiService } from 'src/app/shared/services/api.service';
import { SearchService } from 'src/app/shared/services/search.service';

@Component({
  selector: 'app-doctors-list',
  templateUrl: './doctors-list.component.html',
  styleUrl: './doctors-list.component.css'
})
export class DoctorsListComponent implements OnInit{

  searchResults: any[] = [];
  searchQuery: string = '';
  doctorsList: IDoctor[];
  categoriesList: ICategory[];
  subCategoriesList: ICategory[];
  attendanceVisit: boolean = null;
  isPopular: boolean = null;
  isExperienced: boolean = null;
  expertiesId: number = null;
  tempSort: any = null;

  first: number = 0 ;
  rows: number =  30;
  pageSize = 30;  
  currentpage = 1;
  collectionSize: number = 0;


  @ViewChild('paginator', { static: true }) paginator: Paginator

  private updateCurrentPage(currentPage: number): void {
    setTimeout(() => this.paginator.changePage(currentPage));
  }

  constructor(private searchService: SearchService, public apiService: ApiService) {}

  ngOnInit() {

    // Subscribe to search service
    this.searchService.searchResults$.subscribe((data) => {
      if (data.length > 0) {
        // If search results exist, use them
        this.searchResults = data;
      } else {
        // Otherwise, fetch all data from the API
        this.getDoctorsList(1);
      }
    });
    
    this.getCategoriesList();
  }

  getDoctorsList(page){
    // Subscribe to search results
    // this.searchService.searchResults$.subscribe((results) => {
    //   this.searchResults = results;
    // });

    if(this.tempSort==null || this.tempSort=='null'){
      this.isExperienced = null;
      this.isPopular = null;
    } else if (this.tempSort=='popular'){
      this.isExperienced = null;
      this.isPopular = true;
    } else if (this.tempSort=='experienced'){
      this.isExperienced = true;
      this.isPopular = null;
    }

    const params = {
      pageSize: this.pageSize,
      pageIndex: page,
      medicalExpertId: this.expertiesId,
      mostPopular: this.isPopular,
      maxExperience: this.isExperienced,
      isActiveAttendanceVisit: this.attendanceVisit
    }
    // console.log(params);
    

    this.apiService.apiCall('get', '/api/SiteDoctors/GetAllDoctors', {}, params).subscribe((res: any) => {
      console.log(res);
      
      this.searchResults = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  getCategoriesList() {
    const params = {
      pageIndex: 1,
      pageSize: 200
    }

    this.apiService.apiCall('get', '/api/SiteCategories/GetAllCategories', {}, params).subscribe((res: any) => {
      console.log(res);
      this.categoriesList = res.body.model;
    })
  }

  getSubCategoriesList(categoryId) {    
    const params = {
      pageIndex: 1,
      pageSize: 200
    }

    this.apiService.apiCall('get', '/api/SiteCategories/'+categoryId+'/GetAllSubCategories', {}, params).subscribe((res: any) => {
      console.log(res);
      this.subCategoriesList = res.body.model;
    })
  }

}
